import { __ } from '../Utils';

export default [
  {
    number: 1,
    label: __('Január'),
  },
  {
    number: 2,
    label: __('Február'),
  },
  {
    number: 3,
    label: __('Marec'),
  },
  {
    number: 4,
    label: __('Apríl'),
  },
  {
    number: 5,
    label: __('Máj'),
  },
  {
    number: 6,
    label: __('Jún'),
  },
  {
    number: 7,
    label: __('Júl'),
  },
  {
    number: 8,
    label: __('August'),
  },
  {
    number: 9,
    label: __('September'),
  },
  {
    number: 10,
    label: __('Október'),
  },
  {
    number: 11,
    label: __('November'),
  },
  {
    number: 12,
    label: __('December'),
  },
];



// WEBPACK FOOTER //
// ./src/ContentConfig/mounths.js